<template>
  <div class='box'>
      <div class="header">
        <ul class="pl">
          <li class="fl face"><img src="../../assets/img/examMoni/beforeFace.jpg" alt="" width="86" height="98"></li> 
          <li class="fl info">
          姓 &nbsp;&nbsp;&nbsp;名:XX<br>
          性 &nbsp;&nbsp;&nbsp;别:X<br>
          准考证号:11111111111111<br>
          证件号码:111111111111111111</li>
        </ul>
        <div class="pr">
          <Countdown :time="time" format="hh:mm:ss" @on-end="onCountdownEnd" @on-countdown="onCountdown" style="display:inline-block">
            <template slot-scope="{ time }">科目剩余时间: {{ time }}</template>
          </Countdown>
          <button @click="jiaojuan">交卷</button>
        </div>
        <span v-if="learnType==1">2021年度全国会计专业技术初级资格无纸化考试</span><br/>
        {{toptitle}}
      </div>



      <div class="mainBox" v-if="questionData">



        <div class="left" v-show="isShowLeft">
          <div class="block" v-for="(item,index) in questionData.questionTypes2">
            <div class="title">{{item.type_name}}
              <img src="../../assets/img/examMoni/question_subShow.gif" alt="" v-show="!item.isShow" @click="changeLeftShow(index)">
              <img src="../../assets/img/examMoni/question_subHide.gif" alt="" v-show="item.isShow" @click="changeLeftShow(index)">
            </div>
            <ul v-show="item.isShow">
              <li v-for="(item2,index2) in item.questions" @click="selectThis(item2.i,index2,item.questions.length)">
                {{index2+1}}
                <span v-if="item.question_type<4">
                  <span v-if="questionData.questionList2[item2.i-1].isBJ">?</span>
                  <span v-else-if="!userAnswerObj[item2.question_id]||userAnswerObj[item2.question_id].length==0">*</span>
                </span>
                <span v-else>
                  <span v-if="questionData.questionList2[item2.i-1].isBJ">?</span>
                  <span v-else-if="checkDo(item2.i)">*</span>
                </span>
              </li>
            </ul>
          </div>
          <div class="submark"> 说明：<br>
            1.题号右方的“*”符号代表该小题尚未选择答案。<br>
            2.题号右方的“?”符号代表该小题做过标记。<br>
            3.选择选项的同时自动保存答案。 
          </div>
          <img src="../../assets/img/examMoni/question_jsq.png" class="jsq" alt="" @click="showJSQ">
          <img src="../../assets/img/examMoni/question_showLeft.gif" class="showLeft" alt="" v-show="isShowLeft" @click="isShowLeft=!isShowLeft">
        </div>
        <img src="../../assets/img/examMoni/question_showLeft2.gif" class="showLeft2" alt="" v-show="!isShowLeft" @click="isShowLeft=!isShowLeft">




        <div class="right" :style="{width:isShowLeft?'calc(100% - 410px)':'100%'}">
          <div class="markst">
            <li class="markst_1">试卷</li>
            <button v-if="questionData.questionList2[currIndex-1].type==4" @click="biaoji(true)">标记文字</button>
            <button v-if="questionData.questionList2[currIndex-1].type==4" @click="biaoji(false)">取消标记</button>
          </div>



          <!-- 单项/判断 -->
          <div v-if="questionData.questionList2[currIndex-1].type==1||questionData.questionList2[currIndex-1].type==3">
            <div class="questionTip" v-if="questionData.questionList2[currIndex-1].type==1">
              {{titleNo}}、单项选择题（本类题共{{currLength}}小题，每小题{{currScore}}分，共{{currLength*currScore}}分。每小题备选答案中，只有一个符合题意的正确答案。错选、不选均不得分。请使用计算机鼠标在计算机答题界面上点击试题答案备选项前的按钮“○”作答。）
            </div>
            <div class="questionTip" v-if="questionData.questionList2[currIndex-1].type==3">
              {{titleNo}}、判断题（本类题共{{currLength}}小题，每小题1分，共{{currLength}}分。请判断每小题的表述是否正确。每小题答题正确的得1分，<span v-if="questionData.questionList2[currIndex-1].error_score>0">错答、不答扣{{questionData.questionList2[currIndex-1].error_score}}分</span><span v-else>错答、不答均不得分，也不扣分</span>。请使用计算机鼠标在计算机答题界面上点击试题答案备选项前的按钮“○”作答。）
            </div>
            <div class="contentBox">
              <h3>第<span>{{curr_index+1}}</span>题</h3>
              <div class="questionTitle" v-html="questionData.questionList2[currIndex-1].stem"></div>
              <div class="answerSelectBox">
                <div class="row" v-for="(answer,answerIndex) in questionData.questionList2[currIndex-1].metas">
                  {{answer.key}}.
                  <input type="radio" :name="currIndex" :value="answer.key" v-model="userAnswerObj[questionData.questionList2[currIndex-1].question_id]" :id="currIndex+'-'+answerIndex" @change="selectAnswer(answer.key,questionData.questionList2[currIndex-1].type)">
                  <label :for="currIndex+'-'+answerIndex">{{answer.meta}}</label>
                </div>
              </div>
            </div>
          </div>
          <!-- 多项/不定项 -->
          <div v-else-if="questionData.questionList2[currIndex-1].type==2||questionData.questionList2[currIndex-1].type==4">
            <!-- 多项 -->
            <div class="questionTip" v-if="questionData.questionList2[currIndex-1].type==2">
              {{titleNo}}、多项选择题（本类题共{{currLength}}小题，每小题{{currScore}}分，共{{currLength*currScore}}分。每小题备选答案中，有两个或两个以上符合题意的正确答案。请至少选择两个答案，全部选对得满分，少选得相应分值，多选、错选、不选均不得分。请使用计算机鼠标在计算机答题界面上点击试题答案备选项前的按钮“□”作答。）
            </div>
            <div class="contentBox" v-if="questionData.questionList2[currIndex-1].type==2">
              <h3>第<span>{{curr_index+1}}</span>题</h3>
              <div class="questionTitle" v-html="questionData.questionList2[currIndex-1].stem"></div>
              <div class="answerSelectBox">
                <div class="row" v-for="(answer,answerIndex) in questionData.questionList2[currIndex-1].metas">
                  {{answer.key}}.
                  <input type="checkbox" :name="currIndex" :value="answer.key" v-model="userAnswerObj[questionData.questionList2[currIndex-1].question_id]" :id="currIndex+'-'+answerIndex" @change="selectAnswer(answer.key,questionData.questionList2[currIndex-1].type)">
                  <label :for="currIndex+'-'+answerIndex">{{answer.meta}}</label>
                </div>
              </div>
            </div>
            <!-- 不定项 -->
            <div class="questionTip" v-if="questionData.questionList2[currIndex-1].type==4">
              {{titleNo}}、不定项选择题（本类题共{{t4Length}}小题，每小题{{currScore}}分，共{{t4Length*currScore}}分。每小题备选答案中，有一个或一个以上符合题意的正确答案。每小题全部选对得满分，少选得相应分值，多选、错选、不选均不得分。请使用计算机鼠标在计算机答题界面上点击试题答案备选项前的按钮“□”作答。）
            </div>
            <h3 style="padding:15px 15px 0 15px" v-if="questionData.questionList2[currIndex-1].type==4">第<span>{{curr_index+1}}</span>题</h3>
            <div class="contentBox contentBoxLeft" v-if="questionData.questionList2[currIndex-1].type==4">
              <div class="questionTitle" v-html="questionData.questionList2[currIndex-1].stem"></div>
            </div>

            <div class="contentBox contentBoxRight" v-if="questionData.questionList2[currIndex-1].type==4">
              <div class="block" v-for="block in questionData.questionList2[currIndex-1].questions">
                <div class="questionTitle" v-html="block.self_stem"></div>
                <div class="answerSelectBox">
                  <div class="row" v-for="(answer,answerIndex) in block.metas">
                    {{answer.key}}.
                    <input type="checkbox" :name="block.id" :value="answer.key" v-model="userAnswerObj[block.id]" :id="block.id+'-'+answerIndex" @change="selectAnswer(answer.key,questionData.questionList2[currIndex-1].type,block.id)">
                    <label :for="block.id+'-'+answerIndex">{{answer.meta}}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 填空题 -->
          <div v-else>
            <div class="questionTip" v-if="questionData.questionList2[currIndex-1].type==5&&isShowTitle">
              {{titleNo}}、计算分析题(本类题共{{t5Length}}小题，共{{t5Length*questionData.questionList2[currIndex-1].questions[0].score}}分。凡要求计算的，可不列出计算过程；计算结果出现两位以上小数的，均四舍五入保留小数点后两位小数，百分比指标保留百分号前两位小数。凡要求解释、分析、说明理由的，必须有相应的文字阐述。请在指定答题区域内作答)
            </div>
            <div class="questionTip" v-if="questionData.questionList2[currIndex-1].type==6&&isShowTitle">
              {{titleNo}}、简答题(本类题共{{t6Length}}小题，共{{t6Length*questionData.questionList2[currIndex-1].questions[0].score}}分。凡要求计算的，必须列出计算过程；计算结果出现两位以上小数的，均四舍五入保留小数点后两位小数。凡要求说明理由的，必须有相应的文字阐述。请在指定答题区域内作答)
            </div>
            <div class="questionTip" v-if="questionData.questionList2[currIndex-1].type==8&&isShowTitle">
              {{titleNo}}、综合题(本类题共{{t8Length}}题，共{{t8Length*questionData.questionList2[currIndex-1].questions[0].score}}分。凡要求计算的，必须列出计算过程；计算结果出现两位以上小数的，均四舍五入保留小数点后两位小数。凡要求说明理由的，必须有相应的文字阐述。请在指定答题区域内作答)
            </div>






            <!-- 中级没有-预留 -->
            <!-- <div class="questionTip" v-if="questionData.questionList2[currIndex-1].type==7&&isShowTitle">
              四、填空题(本类题共{{t7Length}}题，共{{t7Length*questionData.questionList2[currIndex-1].questions[0].score}}分。凡要求计算的，必须列出计算过程；计算结果出现两位以上小数的，均四舍五入保留小数点后两位小数。凡要求说明理由的，必须有相应的文字阐述。请在指定答题区域内作答)
            </div>
            <div class="questionTip" v-if="questionData.questionList2[currIndex-1].type==9&&isShowTitle">
              四、计算回答题(本类题共{{t9Length}}题，共{{t9Length*questionData.questionList2[currIndex-1].questions[0].score}}分。凡要求计算的，必须列出计算过程；计算结果出现两位以上小数的，均四舍五入保留小数点后两位小数。凡要求说明理由的，必须有相应的文字阐述。请在指定答题区域内作答)
            </div>
            <div class="questionTip" v-if="questionData.questionList2[currIndex-1].type==10&&isShowTitle">
              四、案例分析题(本类题共{{t10Length}}题，共{{t10Length*questionData.questionList2[currIndex-1].questions[0].score}}分。凡要求计算的，必须列出计算过程；计算结果出现两位以上小数的，均四舍五入保留小数点后两位小数。凡要求说明理由的，必须有相应的文字阐述。请在指定答题区域内作答)
            </div> -->


            <h3 style="padding:15px 15px 0 15px;border-bottom:1px solid #9fb7f7;padding-bottom:4px;font-weight: normal;font-size: 13px;">
              第<span>{{curr_index+1}}</span>题
              <div class="fr">
                <img src="../../assets/img/examMoni/shouqi.png" alt="" v-if="isShowTitle" style="cursor:pointer" @click="isShowTitle=!isShowTitle">
                <img src="../../assets/img/examMoni/zhankai.gif" alt="" v-else style="cursor:pointer" @click="isShowTitle=!isShowTitle">
                <button style="cursor:pointer;margin:0;background:transparent;border:none" @click="biaoji(true)">
                  <img src="../../assets/img/examMoni/bj.gif" alt="">
                  标记文字
                </button>
                <button style="cursor:pointer;margin:0;background:transparent;border:none" @click="biaoji(false)">
                  <img src="../../assets/img/examMoni/nbj.gif" alt="">
                  取消标记
                </button>
              </div>
            </h3>
            <div class="tkMainBox">
              <div class="whiteBox" v-html="questionData.questionList2[currIndex-1].questions[0].stem"></div>
              <ul v-if="questionData.questionList2[currIndex-1].questions.length > 1">
                <li :class="[currTabIndex==index?'panel-active':'']" @click="currTabIndex=index" v-for="(item,index) in questionData.questionList2[currIndex-1].questions">要求({{index+1}})</li>
              </ul>
              <div class="tg">
                <span v-html="questionData.questionList2[currIndex-1].questions[currTabIndex].self_stem"></span>
                <b>请在下方答题区域内作答。</b>
              </div>
              
              <!-- <div class="textarea" contenteditable="true" @input="changeTextarea" v-html="userAnswerObj[questionData.questionList2[currIndex-1].questions[currTabIndex].id]"></div> -->
              <textarea class="textarea" cols="30" rows="10" style="resize: none;" v-model="userAnswerObj[questionData.questionList2[currIndex-1].questions[currTabIndex].id]"></textarea>





            </div>



          </div>




          <div class="bottom">
            <input type="checkbox" id="bj" v-model="questionData.questionList2[currIndex-1].isBJ"><label for="bj">标记</label>
            <button @click="goPre">上一题</button>
            <button @click="goNext">下一题</button>
          </div>
        </div>
      </div>


      <!-- 弹窗区域 -->
      <div class="mask" v-if="isShowWindow!==0">
        <div id="content" class="div_content">
          <div class="dialog_main">
            <div class="dialog_bt"></div>
            <div class="dialog_img">
              <img src="../../assets/img/examMoni/question_ts_2.gif">
            </div>
            <div class="dialog_content">
              <li class="dialog_text">
                <font color="red" v-show="isShowWindow==1">【{{toptitle}}】尚未作答。<br>请确定全部答完后交卷！<br></font>
                <font color="red" v-show="isShowWindow==2">【{{toptitle}}】尚有{{isNoDo}}道题未作答。<br>交卷后将不能返回本科目作答，还要继续交卷吗？</font>
                <font color="red" v-show="isShowWindow==3">再次确认是否交卷？<br>交卷后将不能返回本科目作答！</font>
                <font color="red" v-show="isShowWindow==4">交卷后将不能返回本科目作答，还要继？<br>续交卷吗？</font>
                <font color="red" v-show="isShowWindow==5">本科目将在10分钟后自动收卷，请抓紧<br>时间作答！</font>
                <font color="red" v-show="isShowWindow==10">多选题至少需要选两个答案！</font>
                
              </li>
              <li class="dialog_button">
                <!-- 再次确认 -->
                &nbsp;<img src="../../assets/img/examMoni/question_ts_3.gif" v-show="isShowWindow==3" @click="saveExam">
                <!-- 返回作答 -->
                &nbsp;<img src="../../assets/img/examMoni/question_ts_4.gif" width="84" height="31" @click="isShowWindow=0">
                <!-- 继续交卷 -->
                &nbsp;<img src="../../assets/img/examMoni/question_ts_3.gif" v-show="isShowWindow==2" @click="isShowWindow=3">
                <!-- 交卷确认 -->
                &nbsp;<img src="../../assets/img/examMoni/question_ts_3.gif" v-show="isShowWindow==4" @click="isShowWindow=3">
              </li>
            </div>
          </div>
        </div>
        
      </div>
  </div>
</template>

<script>
import Countdown from "@choujiaojiao/vue2-countdown";
import {Exam,SaveExam} from '@/api/index.js'
export default {
  name: '',
  data() {
    return {
      isShowLeft:true,
      questionData:'',
      currIndex:1,//序号、非索引
      curr_index:0,//当前题类型索引
      currLength:0,//当前类型有多少题
      currScore:1,//当前类型每题几分
      userAnswerObj:{},
      time:0,//考试剩余时间
      isShowWindow:0,//1全部未答2部分未答3二次确认4答完交卷确认5时间快到10多选提示
      isNoDo:0,
      toptitle:'',
      begin_time:'',
      isShowTitle:true,
      t4Length:0,
      t5Length:0,
      t6Length:0,
      t7Length:0,
      t8Length:0,
      t9Length:0,
      t10Length:0,
      learnType:1,
      currTabIndex:0,
      titleNo:'一',
    };
  },
  computed:{
  },
  watch:{
    // 'time':function(newVal,oldVal){
    //   console.log(newVal,oldVal)
    //   let time = newVal
    //   if(time){
    //     this.timer = setInterval(()=>{
    //       time-=1
    //       if(time==600) this.isShowWindow=5
    //     },1000)
    //   }
    // }
  },
  components:{
    Countdown
  },
  methods: {
    // 实验功能
    changeTextarea(e){
      let val = e.target.innerHTML
      console.log(e)
      this.userAnswerObj[this.questionData.questionList2[this.currIndex-1].questions[this.currTabIndex].id] = val

    },
    requery(obj) {
      Exam(obj).then(res => {
        this.questionData = res
        this.begin_time= res.begin_time
        this.time = res.limited_time * 60;
        
        
        for (let i = 0; i < this.questionData.questionTypes2.length; i++) {
          //左侧展开
          this.$set(this.questionData.questionTypes2[i],'isShow',true)
          //初始化选中数据
          if(i==0){
            this.currIndex=0
            this.currIndex=1
            this.currLength=this.questionData.questionTypes2[i].questions.length
            if (this.questionData.questionList2[this.currIndex-1].type < 4) {
              this.currScore = this.questionData.questionList2[this.currIndex-1].score
            }
            else {
              this.currScore = this.questionData.questionList2[this.currIndex-1].questions[0].score
            }
          }
          // 初始化多选
          if(this.questionData.questionTypes2[i].question_type==2){
            for(let item of this.questionData.questionTypes2[i].questions){
              this.$set(this.userAnswerObj,item.question_id,[])
            }
          }else if(this.questionData.questionTypes2[i].question_type==4){
            for(let item of this.questionData.questionTypes2[i].questions){
              for(let item2 of item.questions){
                this.$set(this.userAnswerObj,item2.question_id,[])
              }
            }
          }else if(this.questionData.questionTypes2[i].question_type>4){
            for(let item of this.questionData.questionTypes2[i].questions){
              for(let item2 of item.questions){
                this.$set(this.userAnswerObj,item2.question_id,'')
              }
            }
          }
          
        }
        // list数组index存入
        for(let i=0;i<this.questionData.questionList2.length;i++){
          this.questionData.questionList2[i].index = i
          // t4小题数计算
          if(this.questionData.questionList2[i].type==4){
            for(let j=0;j<this.questionData.questionList2[i].questions.length;j++){
              this.t4Length+=1
            }
          }
          if(this.questionData.questionList2[i].type==5){
            for(let j=0;j<this.questionData.questionList2[i].questions.length;j++){
              this.t5Length+=1
            }
          }
          if(this.questionData.questionList2[i].type==6){
            for(let j=0;j<this.questionData.questionList2[i].questions.length;j++){
              this.t6Length+=1
            }
          }
          if(this.questionData.questionList2[i].type==7){
            for(let j=0;j<this.questionData.questionList2[i].questions.length;j++){
              this.t7Length+=1
            }
          }
          if(this.questionData.questionList2[i].type==8){
            for(let j=0;j<this.questionData.questionList2[i].questions.length;j++){
              this.t8Length+=1
            }
          }
          if(this.questionData.questionList2[i].type==9){
            for(let j=0;j<this.questionData.questionList2[i].questions.length;j++){
              this.t9Length+=1
            }
          }
          if(this.questionData.questionList2[i].type==10){
            for(let j=0;j<this.questionData.questionList2[i].questions.length;j++){
              this.t10Length+=1
            }
          }
        }

        console.log(this.userAnswerObj)
      });
    },
    selectThis(index,i,length){
      if(!this.checkDX()) return
      console.log(index,i,length)
      this.currIndex = index
      this.curr_index=i
      if(length) this.currLength = length
      if (this.questionData.questionList2[this.currIndex-1].type < 4) {
        this.currScore = this.questionData.questionList2[this.currIndex-1].score
      }
      else {
        this.currScore = this.questionData.questionList2[this.currIndex-1].questions[0].score
      }
      this.currTabIndex= 0
      for(let i=0;i<this.questionData.questionTypes2.length;i++){
        if(this.questionData.questionList2[this.currIndex-1].type==this.questionData.questionTypes2[i].question_type){
          let titleNo = i+1
          titleNo = this.numToCN(titleNo)
          this.titleNo = titleNo
          console.log(this.titleNo)
        }
      }
    },
    numToCN(num){
      let changeNum = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
      let unit = ["", "十", "百", "千", "万"];
      num = parseInt(num);
      let getWan = (temp) => {
    　　let strArr = temp.toString().split("").reverse();
    　　let newNum = "";
    　　for (var i = 0; i < strArr.length; i++) {
      　　newNum = (i == 0 && strArr[i] == 0 ? "" : (i > 0 && strArr[i] == 0 && strArr[i - 1] == 0 ? "" : changeNum[strArr[i]] + (strArr[i] == 0 ? unit[0] : unit[i]))) + newNum;
    　　}
    　 return newNum;
      }
      let overWan = Math.floor(num / 10000);
      let noWan = num % 10000;
      if (noWan.toString().length < 4) {　　　　　　noWan = "0" + noWan;　　　 }
      return overWan ? getWan(overWan) + "万" + getWan(noWan) : getWan(num);
      
    },
    goPre(){
      if(this.currIndex!=1){
        let index = this.currIndex-1
        let i = this.questionData.questionList2[index-1].type_index-1
        console.log(this.questionData.questionList2[index])
        this.selectThis(index,i)
      }
    },
    goNext(){
      if(this.currIndex!=this.questionData.questionList2.length){
        let index = this.currIndex+1
        let i = this.questionData.questionList2[index-1].type_index-1
        this.selectThis(index,i)
      }
    },
    changeLeftShow(index){
      this.$set(this.questionData.questionTypes2[index],'isShow',!this.questionData.questionTypes2[index].isShow)
      console.log(this.questionData.questionTypes2[index].isShow)
    },
    selectAnswer(answer,type,id){
      if(type==1||type==3){
        this.$set(this.userAnswerObj,this.questionData.questionList2[this.currIndex-1].question_id,answer)
      }else if(type==2||type==4){
        
      }
      console.log(answer,this.userAnswerObj[id])
    },
    showJSQ(){
      document.getElementById('calculator_Initial').style.display='block'
    },
    // 倒计时结束
    onCountdownEnd(){
      this.saveExam()
    },
    onCountdown(time){
      if(time==600) this.isShowWindow=5
    },
    // 交卷
    jiaojuan(){
      // 答案数组重组字符串
      let answer = JSON.parse(JSON.stringify(this.userAnswerObj))
      for(let key in answer){
        if(typeof answer[key] !== 'string'){
          if(answer[key].length==0) answer[key] = ''
          else answer[key]=answer[key].join("")
        }
      }
      console.log(answer)
      let isNoDo = 0 //未做题数
      let isAllNoDo = true //是否全部未做
      // 过滤校验-弹窗
      for(let item of this.questionData.questionList2){
        if(item.type<4){
          if(answer[item.id]){
            isAllNoDo=false
          }else{
            isNoDo+=1
          }
          
        }else{
          // 父级包含题型处理
          let isNoDoParent = false
          for(let i=0;i<item.questions.length;i++){
            if(answer[item.questions[i].id]){
              isAllNoDo=false
            }else{
              isNoDoParent=true
            }
          }
          if(isNoDoParent) isNoDo+=1
        }
        
      }
      this.isNoDo = isNoDo
      if(isAllNoDo) return this.isShowWindow = 1
      else if(isNoDo>0) return this.isShowWindow = 2
      else return this.isShowWindow = 4

    },
    //交卷提交
    saveExam(){
      this.isShowWindow=0
      // 条数计算
      let length =0
      for(let item of this.questionData.questionList2){
        if(item.type<4) length+=1
        else{
          for(let item2 of item.questions){
            length+=1
          }
        }
      }
      // 答案处理
      let answer = JSON.parse(JSON.stringify(this.userAnswerObj))
      for(let key in answer){
        if(typeof answer[key] !== 'string'){
          if(answer[key].length==0) answer[key] = ''
          else answer[key]=answer[key].join("")
        }
      }
      // return console.log(answer)
      //提交
      let examObj = {};
      examObj.test_id = this.$route.query.test_id;
      examObj.course_id = this.$route.query.course_id;
      examObj.cid = this.$route.query.cid;
      examObj.begin_time = this.begin_time;
      examObj.item_count = length;
      examObj.answers = JSON.stringify(answer);
      SaveExam(examObj).then(res => {
        this.$router.replace(`/examMoni_success?id=${res.id}&exam=exam`)
      })

    },
    biaoji(type){
      if(type){
        // 标记
        // var txt = window.getSelection?window.getSelection().toString():document.selection.createRange().text;
        // console.log(txt)
        // var getRange = () => {
        //   var me = window;
        //   var range = new Range(me.document);
        //   var sel = window.getSelection();
        //   if (sel && sel.rangeCount) {
        //     var firstRange = sel.getRangeAt(0);
        //     var lastRange = sel.getRangeAt(sel.rangeCount - 1);
        //     range.setStart(firstRange.startContainer, firstRange.startOffset).setEnd(lastRange.endContainer, lastRange.endOffset);
        //   }
        //   return range
        // }
        // var range = getRange();
        // range.applyInlineStyle('span', {
        //   class: styles['biaoji']
        // });
        // range.select();
        


        var selecter = window.getSelection();
        console.log(selecter)
        var selectStr = selecter.toString();
        if (selectStr.trim != "") {
          var rang = selecter.getRangeAt(0);
          var ele = document.createElement("span");
          ele.className = 'biaoji';
          ele.textContent = selectStr
          rang.surroundContents(ele);
        }

      }else{
        // 取消标记
        var selecter = window.getSelection();
        var selectStr = selecter.toString();
        if (selectStr.trim != "") {
          var rang = selecter.getRangeAt(0);
          var ele = document.createElement("span");
          ele.className = 'biaoji_cancel';
          ele.textContent = selectStr
          rang.surroundContents(ele);
        }
      }
    },
    // 检查多选
    checkDX(){
      if(this.questionData.questionList2[this.currIndex-1].type!=2) return true

      let answer = this.userAnswerObj[this.questionData.questionList2[this.currIndex-1].id]
      if(answer.length==0) return true
      else if(answer.length==1){
        this.isShowWindow=10
        return false
      }
      else return true
    },
    // 多选已做检查
    checkDo(i){
      // console.log(i)
      for(let item of this.questionData.questionList2[i-1].questions){
        if(this.userAnswerObj[item.id].length==0) return true
      }
      return false
    }


  },
  filters:{
    // isNull:function(vallue){
    //   if(typeof vallue ==='string'){
    //     if(String(vallue).length==0) return false
    //   }else{

    //   }
    //   return true
    // }
  },
  created(){
    document.getElementsByClassName('top_header')[0].style.display='none'
    this.toptitle=this.$route.query.toptitle
    this.learnType=this.$route.query.learn_type

    let obj = {};
    obj.is_moni = 1;
    obj.course_id = this.$route.query.course_id;
    obj.test_id = this.$route.query.test_id;
    obj.rule_tag = this.$route.query.rule_tag;
    obj.course_chapter_id = this.$route.query.course_chapter_id;
    // obj.cid = this.$route.query.cid;
    this.requery(obj);
  },
  mounted () {
    // 禁止复制
    // this.$utils.banCopy()
  },
  destroyed(){

  }
};
</script>

<style lang='scss' scoped>
.box{
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #ddebf6;
  .header{
    height: 101px;
    overflow: hidden;
    width: 100%;
    text-align: center;
    background: url('../../assets/img/examMoni/question_pic02.png') repeat-x;
    color: #FFF;
    font-size: 16px;
    font-weight: bold;
    line-height: 25px;
    text-align: center;
    padding-top: 22px;
    box-sizing: border-box;
    position: relative;
    .pl{
      position: absolute;
      left: 10px;
      top: 2px;
      .info{
        text-align: left;
        padding-left: 4px;
        color: white;
        font-size: 18px;
      }
    }
    .pr{
      position: absolute;
      right: 30px;
      top: 2px;
      font-size: 16px;
    font-weight: bolder;
    color: #ffff00;
      button{
        margin-top: 29px;
        margin-left: 5px;
        width: 81px;
        height: 31px;
        background: url('../../assets/img/examMoni/question_submit.gif') repeat-x;
        border: 1px solid #cc6600;
        color: #000000;
        line-height: 29px;
        font-size: 13px;
        cursor: pointer;
      }
    }
  }
  .mainBox{
    width: 100%;
    height: calc(100% - 102px);
    box-sizing: border-box;
    position: relative;
    .left{
      float: left;
      width: 384px;
      height: 100%;
      border: 1px solid #9fb7f7;
      border-top: none;
      background-color: #eff6fe;
      position: relative;
      .block{
        .title{
          text-align: center;
          background: url('../../assets/img/examMoni/question_leftMenu.gif') repeat-x;
          color: #000000;
          font-size: 14px;
          width: 100%;
          float: left;
          clear: both;
          font-weight: bolder;
          position: relative;
          height: 28px;
          line-height: 28px;
          color: #000000;
          font-size: 14px;
          img{
            position: absolute;
            right: 10px;
            top: 6px;
            cursor: pointer;
          }
        }
        ul{
          li{
            display: inline-block;
            width: 30px;
            height: 28px;
            line-height: 28px;
            text-align: center;
            font-size: 14px;
            font-weight: normal;
            border: 1px solid #FFF;
            background-color: #ddebf6;
            float: left;
            text-decoration: underline;
            color: blue;
            cursor: pointer;
            span{
              color: red;
            }
          }
        }
      }
      .submark{
        clear: both;
        margin: 0px auto 0px 5px;
        padding-top: 5px;
        font-size: 13px;
        color: #F00;
        line-height: 18px;
      }
      .jsq{
        width: 98px;
        height: 38px;
        display: block;
        clear: both;
        margin: 10px auto auto auto;
        cursor: pointer;
      }
    }
    .right{
      height: 100%;
      border: 1px solid #9fb7f7;
      border-top: none;
      background-color: #ddebf6;
      box-sizing: border-box;
      float: left;
      margin-left: 14px;
      padding: 5px;
      color: black;
      position: relative;
      overflow-y: auto;
      .markst{
        background: url('../../assets/img/examMoni/question_n42.gif') repeat-x;
        width: 100%;
        height: 29px;
        .markst_1{
          float: left;
          display: block;
          height: 29px;
          margin-right: 6px;
          width: 109px;
          font-size: 14px;
          font-weight: bolder;
          line-height: 29px;
          background: url('../../assets/img/examMoni/question_markst.png') no-repeat;
          text-align: center;
          color: black;
        }
        button{
          display: block;
          width: 58px;
          height: 21px;
          background: url('../../assets/img/examMoni/question_pic39.jpg') no-repeat;
          float: left;
          margin: 4px 2px auto 0px;
          color: #000000;
          font-size: 12px;
          line-height: 21px;
          text-align: center;
          text-decoration: none;
          border: none;
          cursor: pointer;
        }
      }
      .questionTip{
        font-weight: normal;
        color: #333333;
        font-size: 12pt;
        line-height: 1.5;
        padding: 5px;
        margin: 0px;
        text-align: left;
        border-bottom: 1px solid #9fb7f7;
      }
      h3{
        font-weight: bold;
        font-size: 16px;
        span{
          margin: 0 4px;
        }
      }
      .contentBox{
        line-height: 1.5;
        padding: 15px 15px 40px 15px;
        box-sizing: border-box;
        // height: 400px;
        height: calc(100% - 200px);
        position: absolute;
        .questionTitle{
          font-size: 16px;
        }
        .answerSelectBox{
          font-weight: bold;
          font-size: 16px;
          input{
            margin: 10px 5px 0 2px;
          }
          label{
            font-weight: normal;
            white-space: pre-wrap;
          }
        }
        .block{
          margin-bottom: 32px;
        }
      }
      .contentBoxLeft{
        width: 40%;
        float: left;
        overflow-y: auto;
        left: 0;
      }
      .contentBoxRight{
        width: 60%;
        float: left;
        overflow-y: auto;
        right: 0;
      }

      
      .bottom{
        // margin: 0px auto auto 30px;
        line-height: 21px;
        font-size: 14px;
        position: fixed;
        bottom: 2px;
        right: 0;
        padding-left: 30px;
        background: #ddebf6;
        width: calc(100% - 410px);
        box-sizing: border-box;
        input{
          margin-right: 4px;
        }
        button{
          background: url('../../assets/img/examMoni/question_pic39.jpg') no-repeat;
          width: 58px;
          height: 21px;
          text-align: center;
          border: none;
          line-height: 20px;
          cursor: pointer;
          margin-left: 20px;
        }
      }




    }
  }
}



.showLeft{
  position: absolute;
  width: 10px;
  right: -10px;
  top: 200px;
  cursor: pointer;
}
.showLeft2{
  position: absolute;
  width: 10px;
  left: 0px;
  top: 200px;
  cursor: pointer;
}
.mask{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(128,128,128,.8);
  z-index: 100;
  .div_content{
    position: absolute;
    top: 36%;
    left: 36%;
    width: 526px;
    height: 291px;
    z-index: 101;
  }
  .dialog_main{
    background: url('../../assets/img/examMoni/question_ts_d.gif') no-repeat;
    height: 291px;
    width: 526px;
    li{
      list-style: none;
      padding: 0px;
      margin: 0px;
      display: block;
    }
    .dialog_text{
      width: 280px;
      font-size: 16px;
      font-weight: bolder;
      line-height: 24px;
      min-height: 60px;
    }
  }
  .dialog_bt {
    background: url('../../assets/img/examMoni/question_ts_1.gif') no-repeat;
    height: 40px;
    width: 450px;
    clear: both;
    display: inline-block;
    margin: 24px auto auto 30px;
  }
  .dialog_img {
    float: left;
    background: url('../../assets/img/examMoni/question_ts_2.gif') no-repeat;
    width: 130px;
    height: 135px;
    display: inline-block;
    margin: 25px 0px auto 45px;
  }
  .dialog_content {
    float: left;
    margin: 40px auto auto 40px;
  }
  .dialog_button {
    position: relative;
    left: 0px;
    top: 20px;
    text-align: center;
    img{
      cursor: pointer;
    }
  }
}
.tkMainBox{
  padding: 15px;
  padding-bottom: 25px;
  .whiteBox{
    height: 300px;
    line-height: 30px;
    border-bottom: 3px solid #9fb7f7;
    background-color: #fff;
    overflow: auto;
  }
  ul{
    li{
      display: inline-block;
      padding-bottom: 5px;
      width: 66px;
      height: 25px;
      line-height: 30px;
      font-size: 14px;
      text-align: center;
      cursor: pointer;
      background-image: url('../../assets/img/examMoni/tab.png');
      background-repeat: no-repeat;
    }
    .panel-active{
      background-image: url('../../assets/img/examMoni/tabActive.png') !important;
    }
  }
  .tg{
    
  }
  .textarea{
    box-sizing: border-box;
    overflow-y: auto;
    padding: 8px;
    width: 100%;
    height: 150px;
    background-color: #fff;
    border: 1px solid #333;
  }
}


</style>

<style>
.biaoji{
  background: #ffff00;;
}
.biaoji_cancel{
  background: #ddebf6;
}
.whiteBox .biaoji_cancel{
  background: white;
}
</style>
